<script>
    export let data;
    import {Button} from "carbon-components-svelte";
    import CheckmarkOutline20 from "carbon-icons-svelte/lib/CheckmarkOutline20";
    import EnumStatus from "../services/taskstatus";
    import {updateTask} from "../store";

    function updateTaskDo() {
        data.status = EnumStatus.DONECOMPLETE;
        data = data;
        updateTask(data)
    }

    //let taskid = data.id;
</script>

<Button kind="tertiary" iconDescription="Done" on:click={updateTaskDo} icon={CheckmarkOutline20}
></Button
>
